/** Base64 object. */
export const base64 = {
  /**
   * Encode string to base64.
   *
   * @param {string} str String.
   *
   * @returns {string} Base64 string.
   */
  encodeStr(str: string): string {
    return Buffer.from(str).toString('base64');
  },

  /**
   * Decode base64 to string.
   *
   * @param {string} base64Str Base64 string.
   *
   * @returns {string} String.
   */
  decodeStr(base64Str: string): string {
    return Buffer.from(base64Str, 'base64').toString();
  },

  /**
   * Encode object to base64.
   *
   * @template TData Data type.
   * @param {TData} obj Object.
   *
   * @returns {string} Base64 string.
   */
  encodeObj<TData extends object>(obj: TData): string {
    const json = JSON.stringify(obj);
    return Buffer.from(json).toString('base64');
  },

  /**
   * Decode base64 to object.
   *
   * @template TData Data type.
   * @param {string} base64Str Base64 string.
   *
   * @returns {TData} Object.
   */
  decodeObj<TData extends object>(base64Str: string): TData {
    const json = Buffer.from(base64Str, 'base64').toString();
    return JSON.parse(json);
  },

  /**
   * Encode file to base64.
   *
   * @param {File} file File.
   *
   * @returns {string} Base64 string.
   */
  async encodeFile(file: File): Promise<string> {
    const buffer = await file.arrayBuffer();
    const binary = new Uint8Array(buffer).reduce((prev, byte) => prev + String.fromCharCode(byte), '');

    return btoa(binary);
  },
};
